import { connect } from 'react-redux';
import { apiActions as nucleusApiActions } from '@lifesize/nucleus';
import FavoriteStar from 'components/FavoriteStar/FavoriteStar';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch =>
  ({
    handleFavoriteToggle: (contactId, toggle) =>
      dispatch(nucleusApiActions.contactSetFavorite(contactId, toggle)),
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FavoriteStar);
